import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { SecurityService } from '@wms/settings/security';
import { FormsModule, NgForm } from '@angular/forms';
import { includes, isEqual } from 'lodash-es';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.less'],
  imports: [FormsModule]
})
export class CustomComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  security: any;
  securityService: SecurityService;
  formChangesSubscription: Subscription;
  resetFormSubscription: Subscription;
  @ViewChild('customForm', { static: true }) ngForm: NgForm;

  constructor() {
    super();
    this.securityService = inject(SecurityService);
  }

  ngOnInit(): void {
    this.security = this.securityService.security;
    if (this.security.enableSecurity) {
      //hiding error messages if any, since provider was changed
      // TODO -  needed?
      // this.hideMessage();
    }
    this.securityService.getCustomOptions(this.authInfo);
    this.security.showUnamePass = true;
    // TODO
    // this.handleWatchers(provider);
    //don't initialize if 'prevProvider' is same as 'provider'
    let setInitialValue: boolean = true;
    if (this.securityService.customFormInitialValue) {        
      setInitialValue = false;
      setTimeout(() => {
        this.ngForm.form.patchValue(this.securityService.customFormInitialValue);
      });
    }

    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(val => {
      if (!this.ngForm.form.dirty && setInitialValue) {
        this.securityService.customFormInitialValue = this.ngForm.form.value;
      }
      if (this.ngForm.form.dirty) {
        if (isEqual(this.securityService.customFormInitialValue, this.ngForm.form.value)) {
          this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('customProvider', 1));
        } else if (!includes(this.security.dirtyCheckList, 'customProvider')) {
          this.security.dirtyCheckList.push('customProvider');
        }
      }
    });


    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.ngForm.form.reset(this.securityService.customFormInitialValue);
      } else {
        this.securityService.customFormInitialValue = this.ngForm.form.value;
      }
    });

    if (this.securityProps.prevProvider === 'CUSTOM') {
      return;
    }
  }

  override ngOnDestroy(): void {
    this.formChangesSubscription?.unsubscribe();
    this.resetFormSubscription?.unsubscribe();
  }
}
